import { MassText, MassTextType, ScheduleTextInfo } from "@markit/common.types";
import { MassTextSendTime } from "../Message/MassTextSendTime";
import QuietHoursNotice from "../QuietHours/QuietHoursNotice";
import { MassTextRelativeSendTime } from "../Message/MassTextRelativeSendTime";
import { isDefaultTemplateAutomations } from "@markit/common.utils";

export type MassTextsSendScheduleProps = {
  massText: MassText;
  scheduleTextInfo: ScheduleTextInfo;
  setScheduleTextInfo: (scheduleTextInfo: ScheduleTextInfo) => void;
  isEditing: boolean;
};

const MassTextsSendSchedule = (props: MassTextsSendScheduleProps) => {
  const { massText, scheduleTextInfo, setScheduleTextInfo, isEditing } = props;

  return (
    <div
      className="ColumnNormal"
      style={{ height: "100%", padding: 14, gap: 14 }}
    >
      {massText.type === MassTextType.TRIGGERTEXT ||
      isDefaultTemplateAutomations(massText.campaignId) ? (
        <MassTextRelativeSendTime
          scheduleTextInfo={scheduleTextInfo}
          setScheduleTextInfo={setScheduleTextInfo}
          campaignId={massText.campaignId}
        />
      ) : (
        <MassTextSendTime
          scheduleTextInfo={scheduleTextInfo}
          setScheduleTextInfo={setScheduleTextInfo}
          isEditing={isEditing}
        />
      )}
      {/** TODO: Hidden after new automation stuff, re-add it down the road when we want this functionality back */}
      {/* {massText.eventRefId ? (
        <MassTextCatchUp
          massText={massText}
          catchUpChecked={scheduleTextInfo.catchUpChecked}
          setCatchUpChecked={(catchUp: boolean) =>
            setScheduleTextInfo({
              ...scheduleTextInfo,
              catchUpChecked: catchUp,
            })
          }
          theme={theme}
        />
      ) : null} */}
      <QuietHoursNotice
        scheduleTextInfo={scheduleTextInfo}
        setScheduleTextInfo={setScheduleTextInfo}
      />
    </div>
  );
};

export default MassTextsSendSchedule;
